import React from 'react';
import CaseStudiesSlider from './CaseStudiesSlider';

const CaseStudiesSliderWithProps = (props: any) => {
  return (
    <CaseStudiesSlider
      sectionTitle={props.sectionTitle}
      sectionDescription={props.sectionDescription}
      sectionCtaLabel={props.sectionCtaLabel}
      sectionCtaLink={props.sectionCtaLink}
      caseStudies={props.caseStudies}
    />
  );
};

export default CaseStudiesSliderWithProps;
